let HELP_OBJECT = {
   "name": "",
   "email": "",
   "userName": "",
   "phone": "",
   "patientName": "",
   "patientDOB": "",
   "reason": "",
  // "issue": { id:0, value: "", label: "Select one"},
  "issue": "",
 //  "device": { id:0, value: "", label: "Select one"},
 "device": "",
   "deviceOther": "",
   "isApp": "",
   "browser": ""
  // "isApp": { id:0, value: "", label: "Select one"},
  // "browser": { id:0, value: "", label: "Select one"}
};

export {HELP_OBJECT};